// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PUnlockOutlinedSvg from "@fishx/icons-svg/es/asn/PUnlockOutlined";
import FishxIcon from '../components/FishxIcon';

var PUnlockOutlined = function PUnlockOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PUnlockOutlinedSvg
  }));
};

PUnlockOutlined.displayName = 'PUnlockOutlined';
export default React.forwardRef(PUnlockOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PUnlockOutlined.js
// module id = 3706
// module chunks = 0